<template>
  <div class="container">
    <Card shadow>
<!--      <div>-->
<!--        <Breadcrumb>-->
<!--          <BreadcrumbItem to="/">首页</BreadcrumbItem>-->
<!--          <BreadcrumbItem>填写信息</BreadcrumbItem>-->
<!--        </Breadcrumb>-->
<!--      </div>-->
      <input type="hidden" name="captchaId" :value="captchaId">
      <div id="captcha"></div> <!-- 验证码容器元素 -->
      <SaleStep :current="current"></SaleStep>
      <div class="form-wrap">
        <!-- 表单 -->
        <Form ref="formCustom" :model="formCustom" :rules="ruleCustom" :label-width="120">
          <div class="ticket-title row-margin">
            <h3>门票</h3>
            <Button
              class="x-text-btn"
              icon="ios-alert"
              @click="showNeedKnow"
              type="text">
              购买须知
            </Button>
          </div>
          <Row>
            <Col span="8">
              <FormItem label="门票名称">
                <div style="float:right;margin-right:60px;margin-top:1px;">{{singleInfo.displayName}}</div>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem label="单价">
                <span class="monovalent">{{singleInfo.salePrice}}元</span>
              </FormItem>
            </Col>
          </Row>
          <h3 class="row-margin">日期</h3>
          <Row>
            <Col span="24">
              <FormItem label="游玩日期" prop="playDate">
                <x-date
                  :val="formCustom.playDate"
                  :dateList="singleInfo.saleDateInfos"
                  @dateChange="dateChange"
                  v-model="formCustom.playDate"></x-date>
<!--                <Select v-model="formCustom.playDate" @on-change="timeChange">-->
<!--                  <Option v-for="item in singleInfo.saleDateInfos" :value="item.playDate" :key="item.playDate">{{ item.playDate }}</Option>-->
<!--                </Select>-->
              </FormItem>
            </Col>
            <Col span="24">
              <FormItem label="入园时段" prop="playPeriodId">
                <x-time
                  :val="formCustom.playPeriodId"
                  :dateList="playInterval"
                  @timeChange="timeChange"
                  v-model="formCustom.playPeriodId"></x-time>
<!--                <Select v-model="formCustom.playPeriodId">-->
<!--                  <Option v-for="item in playInterval" v-if="!item.expiredFlag && !item.sellOutFlag" :value="item.periodCode" :key="item.periodCode">-->
<!--                    {{ item.periodName }} ({{item.beginTime}} - {{item.endTime}}) 余票 {{item.resouceCount}}-->
<!--                  </Option>-->
<!--                </Select>-->
              </FormItem>
            </Col>
          </Row>
          <h3 class="row-margin">游览人</h3>
          <Row>
            <Col span="7">
              <FormItem label="选择人数">
                <div class="number-input">
                  <Icon class="remove-icon" type="md-remove" @click="changeCount('reduce')" />
                  <input v-model="formCustom.playCount" type="text" @input="playCountChange($event)" @blur="playCountBlur($event)">
                  <Icon class="add-icon" type="md-add" @click="changeCount('add')" />
                </div>
              </FormItem>
            </Col>
            <Col span="12">
              <span style="line-height: 32px; color: #CCCCCC;">（同一用户同一使用日期限购1单，每单最多可购{{singleInfo.maxCountPerOrder}}份）</span>
            </Col>
          </Row>
          <Row v-for="(item, index) in traverllerList" :key="item.id">
            <Col :span="traverllerCol" v-if="showTraverllerCol(traverllerCerList)">
              <x-select
                :val="item.traverllerCerType"
                :idx="index"
                label="证件类型"
                :cerList="traverllerCerList"
                :type="item.traverllerCerType"
                prop="traverllerCerType"
                ref="xComponent"
                @isValidate="isValidate"
                @communication="communication($event, index, 'traverllerCerType')"
                v-model="item.traverllerCerType"></x-select>
            </Col>
            <Col :span="traverllerCol" v-if="singleInfo.needTravellerName == 'true'">
              <x-input
                :val="item.traverllerName"
                :idx="index"
                label="姓名"
                :type="item.traverllerCerType"
                prop="traverllerName"
                ref="xComponent"
                @isValidate="isValidate"
                @communication="communication($event, index, 'traverllerName')"
                v-model="item.traverllerName"></x-input>
            </Col>
            <Col :span="traverllerCol" v-if="singleInfo.needTravellerEmail == 'true'">
              <x-input
                :val="item.traverllerEmail"
                :idx="index"
                label="邮箱"
                :type="item.traverllerCerType"
                prop="traverllerEmail"
                ref="xComponent"
                @isValidate="isValidate"
                @communication="communication($event, index, 'traverllerEmail')"
                v-model="item.traverllerEmail"></x-input>
            </Col>
            <Col :span="traverllerCol" v-if="singleInfo.needTravellerMobile == 'true'">
              <x-input
                :val="item.traverllerPhone"
                :idx="index"
                label="电话"
                :type="item.traverllerCerType"
                prop="traverllerPhone"
                ref="xComponent"
                @isValidate="isValidate"
                @communication="communication($event, index, 'traverllerPhone')"
                v-model="item.traverllerPhone"></x-input>
            </Col>
            <Col :span="traverllerCol" v-if="showTraverllerCol(traverllerCerList)">
              <x-input
                :val="item.traverllerCerNo"
                :idx="index"
                label="证件号码"
                :type="item.traverllerCerType"
                :other="traverllerList"
                :saleAge="formCustom"
                prop="traverllerCerNo"
                ref="xComponent"
                @isValidate="isValidate"
                @communication="communication($event, index, 'traverllerCerNo')"
                v-model="item.traverllerCerNo"></x-input>
            </Col>
            <Icon
              type="ios-remove-circle-outline"
              class="delete-traverller"
              @click="deleteTraverller(index)"
              v-if="traverllerList.length > 1" />
          </Row>
          <h3 class="row-margin">联系人</h3>
          <Row v-for="item in 1">
            <Col :span="contactCol" v-if="showContactCol(contactCerList)">
              <x-select
                :val="formCustom.contactCerType"
                label="证件类型"
                :cerList="contactCerList"
                :type="formCustom.contactCerType"
                prop="contactCerType"
                ref="xComponent"
                @isValidate="isValidate"
                @communication="communication($event, -1, 'contactCerType')"
                v-model="formCustom.contactCerType"></x-select>
            </Col>
            <Col :span="contactCol" v-if="singleInfo.needContactName == 'true'">
              <x-input
                :val="formCustom.contactName"
                label="联系人"
                :type="formCustom.contactCerType"
                prop="contactName"
                ref="xComponent"
                @isValidate="isValidate"
                @communication="communication($event, -1, 'contactName')"
                v-model="formCustom.contactName"></x-input>
            </Col>
            <Col :span="contactCol" v-if="singleInfo.needContactMobile == 'true'">
              <x-input
                :val="formCustom.contactPhone"
                label="联系电话"
                :type="formCustom.contactCerType"
                prop="contactPhone"
                ref="xComponent"
                @isValidate="isValidate"
                @communication="communication($event, -1, 'contactPhone')"
                v-model="formCustom.contactPhone"></x-input>
            </Col>
            <Col :span="contactCol" v-if="singleInfo.needContactEmail == 'true'">
              <x-input
                :val="formCustom.contactEmail"
                label="邮箱"
                :type="formCustom.contactCerType"
                prop="traverllerCerNo"
                ref="xComponent"
                @isValidate="isValidate"
                @communication="communication($event, -1, 'contactEmail')"
                v-model="formCustom.contactEmail"></x-input>
            </Col>
            <Col :span="contactCol" v-if="showContactCol(contactCerList)">
              <x-input
                :val="formCustom.contactCerNo"
                label="证件号码"
                :type="formCustom.contactCerType"
                prop="contactCerNo"
                ref="xComponent"
                @isValidate="isValidate"
                @communication="communication($event, -1, 'contactCerNo')"
                v-model="formCustom.contactCerNo"></x-input>
            </Col>
          </Row>
        </Form>
        <div class="line"></div>
        <Row style="margin-top: 24px;">
          <Col span="12">
            <div class="total-wrap">
              <span class="price-label">订单总金额</span>
              <span class="total-price">{{totalPrice}}<span class="unit">元</span></span>
            </div>
          </Col>
          <Col span="12" style="text-align: right;">
            <Button type="primary" :loading="btnLoading" class="next-btn" @click="handleSubmit('formCustom')">下一步</Button>
          </Col>
        </Row>
        <Spin size="large" fix v-if="spinShow"></Spin>
      </div>
    </Card>
    <!-- 登陆框 -->
    <Modal
      :value="showModal"
      :footer-hide="true"
      @on-cancel="closeModal"
      class-name="vertical-center-modal">
      <p slot="header" style="height:40px;vartical-align:middle">
        <img src="@/assets/logo.png" style=" height: 40px; vertical-align: middle;">
        <span style="margin-left:20px">* 扫码登录</span>
      </p>
      <div style="text-align:center;margin-bottom:20px;min-height: 350px;">
        <Login @closeModal="closeModal" v-if="showModal"></Login>
      </div>
    </Modal>
    <!-- /登陆框 -->

    <!-- 购票须知 -->
    <x-modal :value="needKnowShow" :content="singleInfo.description" @toClose="toClose"></x-modal>
  </div>
</template>

<script>
import Vue from "vue"
import Login from '@/components/login/login.vue'
import { httpAction } from '@/api/manage'
import { cerList, ticketInfo } from '@/util/public'
import SaleStep from '@/components/saleStep/Index'
import XInput from '@/components/xInput/index'
import XSelect from '@/components/xSelect/index'
import xModal from '@/components/xModal/index'
import xDate from '@/components/xDate/index'
import xTime from '@/components/xTime/index'
import common from '@/util/common'
import cstaticdun from "@/util/cstaticdun"
import api from '@/api'
import moment from "moment"
export default {
  name: 'purchase-info',
  components: {
    SaleStep,
    'x-input': XInput,
    'x-select': XSelect,
    'x-modal': xModal,
    'x-date': xDate,
    'x-time': xTime,
    Login
  },
  data () {
    const validateFun = (rule, value, callback) => {
      if (!value) {
        let errorStr = ''
        if (rule.field === 'playDate') {
          errorStr = '请选择游玩日期'
        } else if (rule.field === 'playPeriodId') {
          errorStr = '请选择入园时段'
        }
        return callback(new Error(errorStr))
      } else {
        return callback()
      }
    }
    return {
      // url: {
      //   single: '/yhy/openapi/web/product/single',
      //   newSingle: '/openapi/ticket/detail',
      //   resourceList: '/openapi/resource/list',
      //   createOrder: '/yhy/openapi/web/pc/individual/createOrder'
      // },
      current: 1,
      formCustom: {
        playDate: '',
        playPeriodId: '',
        playCount: 1,
        contactName: '',
        contactPhone: '',
        contactCerType: '',
        contactEmail: '',
        contactCerNo: '',
        saleAgeInfos: {}
      },
      ruleCustom: {
        playDate: [
          { required: true, validator: validateFun, trigger: 'blur' }
        ],
        playPeriodId: [
          { required: true, validator: validateFun, trigger: 'blur' }
        ]
      },
      singleInfo: {},
      spinShow: false,
      playInterval: [],
      salePeriodList: [],
      cerList,
      traverllerCerList: [],
      contactCerList: [],
      traverllerList: [
        { id: `x-component_${Math.round(Math.random()*1000)}${this.count}`, traverllerCerType: '', traverllerName: '', traverllerCerNo: '', traverllerEmail: '', traverllerPhone: '' }
      ],
      deleteShow: false,
      modal_loading: false,
      traverllerColNum: 0,
      contactColNum: 0,
      submitFalse: 0,
      submitTrue: 0,
      totalFlag: 0,
      originalNum: 1,
      resourceCount: 10,
      showModal: false,
      captchaIns: null,
      btnLoading: false,
      needKnowShow: false,
      captchaId: process.env.VUE_APP_CAPTCHA,
      count: 1,
      contactCerts: [],
      travellerCerts: []
      // captchaId: 'fb2e9b92b8f941c4b3ba6d33062c41e6'
      // captchaId: 'e21873fea68b49a1a93630b53cc92f69'
    }
  },
  beforeRouteEnter (to, from, next) {
    const type = common.userType()
    // 阻止用户用不同权限的账号登陆购买其他权限的门票
    if (type === '1') {
      next(vm => {
        vm.$Message.warning('权限异常！')
        vm.$router.push('/error')
      })
    } else {
      next(vm => {
        vm.getSingle()

      })
    }
  },
  mounted () {
    this.salePeriodList = JSON.parse(window.localStorage.getItem('salePeriodList'))
    if (this.salePeriodList == null || this.salePeriodList == undefined) {
      this.getNewPeriod()
      // console.log('111')
    }
    const that = this
    // 网易校验
    if(that.captchaId){
      cstaticdun({
        element: '#captcha',
        captchaId: that.captchaId,
        mode: 'bind', // 仅智能无感知验证码时，mode 才能设置为 bind
        width: '320px',
        // enableClose: true, // 由业务方控制验证码弹框关闭
        // feedbackEnable: false, // 业务方关闭反馈入口
        onVerify: function(err){
          console.log("验证结果", err)
          if (!err) {
            that.handleCreate()
          }
        },
        onClose: function () {
          that.spinShow = false
        }
      }, function (instance) {
        that.captchaIns = instance
        that.spinShow = false
      }, function (err) {
        console.log(err)
        that.spinShow = false
      })
    }else{
    }
  },
  watch: {
    totalFlag: { // 监听 封装的组件校验情况
      deep: true,
      handler (newVal, oldVal) {
        let totalColNum = (this.traverllerColNum * this.formCustom.playCount) + this.contactColNum
        let submitNum = this.submitFalse + this.submitTrue
        if (totalColNum === submitNum) { // 说明所有子组件都检验完成
          if (newVal === totalColNum) { // 如果校验之后, totalFlag 等于总数, 说明所有控件都过了校验, 那么走创建请求
            // 人机验证框架
            //Mod by LiuHui at 2021-05-24 验证码不刷新 begin
            if (this.captchaIns && this.captchaIns.refresh()) {
            // if (this.captchaIns) {
              //Mod by LiuHui at 2021-05-24 验证码不刷新 end
              this.captchaIns.verify()
            } else {
              this.handleCreate()
            }
            // const obj = this.handleData()
            // httpAction(this.url.createOrder, 'post', obj).then(res => {
            //   if (res.status === '0') {
            //     // Vue.ls.set('orderId', res.data.orderId)
            //     this.$router.push({ path: '/purchase/pay', query: { orderId: res.data.orderId } })
            //   } else {
            //     this.$Message.warning(res.message)
            //   }
            //   // this.singleInfo = res.data
            // })
          } else {
            this.spinShow = false
          }
        } else {
          this.spinShow = false
          console.log("未匹配totalColNum")
        }
      }
    }
  },
  computed: {
    totalPrice () { // 总价
      let playCount = this.formCustom.playCount === 0 ? 1 : this.formCustom.playCount
      const num = (this.singleInfo.salePrice * playCount).toFixed(2)
      return num
    },
    traverllerCol () { // 游览人列宽
      const singleInfo = this.singleInfo
      const keyList = {
        needTravellerName: singleInfo.needTravellerName === 'true',
        needTravellerEmail: singleInfo.needTravellerEmail === 'true',
        needTravellerMobile: singleInfo.needTravellerMobile === 'true'
      }

      let colNum = 0
      let cardFalg = false
      for (const key in keyList) {
        if (keyList[key]) {
          colNum += 1
        }
      }
      if (this.travellerCerts.length > 0) {
        cardFalg = true
      }
      if (cardFalg) colNum += 2
      this.traverllerColNum = colNum
      const col = Math.floor(24 / colNum) > 12 ? 12 : Math.floor(24 / colNum)
      return col
    },
    contactCol () { // 联系人列宽
      const singleInfo = this.singleInfo
      const keyList = {
        needContactEmail: singleInfo.needContactEmail === 'true',
        needContactName: singleInfo.needContactName === 'true',
        needContactMobile: singleInfo.needContactMobile === 'true'
      }

      let colNum = 0
      let cardFalg = false
      for (const key in keyList) {
        if (keyList[key]) {
          colNum += 1
        }
      }
      if (this.contactCerts.length > 0) {
        cardFalg = true
      }
      if (cardFalg) colNum += 2
      this.contactColNum = colNum
      const col = Math.floor(24 / colNum) > 12 ? 12 : Math.floor(24 / colNum)
      return col
    }
  },
  destroyed() {
    this.captchaIns = null
  },
  methods: {
    async getNewPeriod () {
      const obj = {
        codes: ['salePeriodList'],
        dataLocationType: 'latest',
        tenantCode: 'XSGY'
        // appCode: 1,
        // version: 1,
        // parkId: 1
      }
      const res = await httpAction(api.newPeriodList, 'post', obj)
      const salePeriodList = res.data.codeInfos[0].describe
      // console.log(JSON.parse(salePeriodList))
      window.localStorage.setItem('salePeriodList', JSON.stringify(JSON.parse(salePeriodList)))
      this.salePeriodList = JSON.parse(window.localStorage.getItem('salePeriodList'))
    },
    handleCreate () { // 创建订单
      const that = this
      const obj = that.handleData()
      httpAction(api.indiCreateOrder, 'post', obj).then(res => {
        if (res && res.status === '0') {
          // Vue.ls.set('orderId', res.data.orderId)
          // that.captchaIns.close()
          that.$router.push({ path: '/purchase/pay', query: { orderId: res.data.orderId } })
          that.spinShow = false
        } else {
          that.captchaIns && that.captchaIns.refresh()
        }
        that.spinShow = false
      })
    },
    dateChange(data) {
      this.$set(this.formCustom, 'playDate', data.saleDate)
      this.$set(this, 'playInterval', data.datePeriodInfos)
      this.$set(this.formCustom, 'playPeriodId', '')
    },
    timeChange(code) {
      this.$set(this.formCustom, 'playPeriodId', code)
    },
    closeModal () {
      this.showModal = false
    },
    deleteTraverllerList (type, num) { // 控件批量删除
      // type: all--全部删除，只留第一个  part--部分删除，根据减少的数值删除对应的控件
      let hasText = 0
      this.traverllerList.forEach((item, index) => {
        if (num) {
          if (index > (this.traverllerList.length + num - 1)) {
            if (item.traverllerName || item.traverllerCerNo || item.traverllerEmail || item.traverllerPhone) {
              hasText += 1
            }
          }
        } else {
          if (index > 0) {
            if (item.traverllerName || item.traverllerCerNo || item.traverllerEmail || item.traverllerPhone) {
              hasText += 1
            }
          }
        }
      })
      if (type === 'all') {
        if (hasText > 0) {
          this.$Modal.confirm({
            title: '删除操作',
            content: '是否删除已填写的游览人信息?',
            onOk: () => {
              this.traverllerList.splice(1)
            }
          })
        } else {
          this.traverllerList.splice(1)
        }
      } else {
        if (hasText > 0) {
          this.$Modal.confirm({
            title: '删除操作',
            content: '是否删除已填写的游览人信息?',
            onOk: () => {
              const delStartNum = this.traverllerList.length + num
              this.traverllerList.splice(delStartNum, Math.abs(num))
            }
          })
        } else {
          const delStartNum = this.traverllerList.length + num
          this.traverllerList.splice(delStartNum, Math.abs(num))
        }
      }
    },
    playCountChange (event) { // 人数控件只能输入数字
      const maxNum = this.singleInfo.maxCountPerOrder * 1
      let value = event.target.value.replace(/[^\d]/g, '') * 1
      // let keyDowm = event.data ? event.data.replace(/[^\d]/g, '') * 1 : ''
      if (value > maxNum) {
        value = maxNum
      }
      this.$set(this.formCustom, 'playCount', value * 1)
    },
    playCountBlur (event) { // 人数选择控件 blur 事件
      let value = event.target.value
      const oldVal = this.originalNum
      if (this.formCustom.playCount === 0) {
        this.$set(this.formCustom, 'playCount', 1)
        this.originalNum = 1
      }
      if (value !== '0') {
        let difference = value * 1 - oldVal
        if (difference > 0) {
          for (let i = 0; i < difference; i++) {
            this.changeTraverllerList('add', 'input')
          }
        } else {
          this.deleteTraverllerList('part', difference)
        }
        this.originalNum = value * 1
      } else {
        this.deleteTraverllerList('all')
      }
    },
    isValidate (event) { // 验证自定义控件的校验通过数量
      if (event === 1) {
        this.submitTrue += 1
      } else {
        this.submitFalse += 1
      }
      this.totalFlag += event
    },
    communication (data, index, key) { // 手动实现双向绑定
      if (index === -1) {
        this.$set(this.formCustom, key, data)
      } else {
        this.$set(this.traverllerList[index], key, data)
      }
      this.$forceUpdate()
    },
    deleteTraverller (index) { // icon 删除
      const nowList = this.traverllerList[index]
      if (nowList.traverllerName || nowList.traverllerCerNo || nowList.traverllerEmail || nowList.traverllerPhone) {
        this.$Modal.confirm({
          title: '删除操作',
          content: '是否删除该该游览人信息?',
          onOk: () => {
            this.formCustom.playCount -= 1
            this.originalNum -= 1
            this.traverllerList.splice(index, 1)
            this.$forceUpdate()
          }
        })
      } else {
        this.formCustom.playCount -= 1
        this.originalNum -= 1
        this.traverllerList.splice(index, 1)
      }
    },
    toClose() {
      this.needKnowShow = false
    },
    showNeedKnow () { // 购买须知
      // this.$Modal.info({
      //   title: '购买须知',
      //   content: this.singleInfo.description,
      //   width: 800,
      //   okText: ''
      // })
      this.needKnowShow = true
    },
    showTraverllerCol (list) { // 游览人证件类型和证件是否显示
      const flagVal = list.length > 0
      return flagVal
    },
    showContactCol (list) { // 联系人证件类型和证件是否显示
      const flagVal = list.length > 0
      return flagVal
    },
    changeCount (type) { // 人数控件 icon 增加/减少 操作
      const num = this.formCustom.playCount
      const maxNum = this.singleInfo.maxCountPerOrder
      if (type === 'add') {
        if (num < maxNum) {
          this.changeTraverllerList('add')
        }
      } else {
        if (num > 1) {
          this.changeTraverllerList('reduce')
        }
      }
    },
    changeTraverllerList (type, method) { // 动态更新控件数量
      if (type === 'add') {
        if (!method) {
          this.formCustom.playCount += 1
          this.originalNum += 1
        }
        this.count += 1
        this.traverllerList.push({ id: `x-component_${Math.round(Math.random()*1000)}${this.count}`, traverllerCerType: this.traverllerCerList[0].value, traverllerName: '', traverllerCerNo: '', traverllerEmail: '', traverllerPhone: '' })
      } else {
        const lastArr = this.traverllerList[this.traverllerList.length - 1]
        if (lastArr.traverllerName || lastArr.traverllerCerNo || lastArr.traverllerEmail || lastArr.traverllerPhone) {
          this.$Modal.confirm({
            title: '删除操作',
            content: '是否删除该该游览人信息?',
            onOk: () => {
              if (!method) {
                this.formCustom.playCount -= 1
                this.originalNum -= 1
              }
              this.traverllerList.pop()
            }
          })
        } else {
          if (!method) {
            this.formCustom.playCount -= 1
            this.originalNum -= 1
          }
          this.traverllerList.pop()
        }
      }
    },
    // timeChange (data) { // 游玩日期change时，更新游玩时段
    //   this.formCustom.playPeriodId = ''
    //   const saleDateInfos = this.singleInfo.saleDateInfos
    //   const checkOn = saleDateInfos.find(item => item.playDate === data)
    //   this.playInterval = checkOn ? checkOn.periods : []
    // },
    handleData () { // 处理最终提交data
      console.log(this.formCustom)
      const typeFlag = this.singleInfo.needCertAsMedia
      let NECaptchaValidate = null;
      if(this.captchaIns){
        NECaptchaValidate = document.querySelector('input[name=NECaptchaValidate]').value
      }
      const obj = {
        contactName: this.formCustom.contactName,
        contactPhone: this.formCustom.contactPhone,
        contactEmail: this.formCustom.contactEmail,
        contactCerType: this.formCustom.contactCerType,
        contactCerNo: this.formCustom.contactCerNo,
        payType: 'WEIXIN',
        orderItems: [],
        orderAttrs: [],
        orderSource: 'PC',
        validateCode: NECaptchaValidate
      }
      const productId = this.$route.query.id ? this.$route.query.id : ''
      // const productId = Vue.ls.get('productId')
      // 计算新的时段编码
      const periodList = this.salePeriodList.filter((item) => item.playPeriodCode === this.formCustom.playPeriodId)
      console.log(periodList)
      if (typeFlag) {
        const arr = []
        this.traverllerList.forEach(item => {
          arr.push({
            ticketId: productId,
            traverllerName: item.traverllerName,
            traverllerPhone: item.traverllerPhone,
            traverllerEmail: item.traverllerEmail,
            traverllerCerType: item.traverllerCerType,
            traverllerCerNo: item.traverllerCerNo,
            playCount: '1',
            playDate: this.formCustom.playDate,
            playPeriodId: periodList[0].playPeriodId,
            playPeriodCode: periodList[0].playPeriodCode,
            playPeriodName: periodList[0].playPeriodDisplay,
            playPeriodStartTime: periodList[0].playPeriodStartTime,
            playPeriodEndTime: periodList[0].playPeriodEndTime,
            attrList: [{
              traverllerName: item.traverllerName,
              traverllerPhone: item.traverllerPhone,
              traverllerEmail: item.traverllerEmail,
              traverllerCerType: item.traverllerCerType,
              traverllerCerNo: item.traverllerCerNo
            }]
          })
        })
        obj.orderItems = arr
      } else {
        const arr = [{
          ticketId: productId,
          traverllerName: '',
          traverllerPhone: '',
          traverllerEmail: '',
          traverllerCerType: '',
          traverllerCerNo: '',
          playCount: this.formCustom.playCount,
          playDate: this.formCustom.playDate,
          playPeriodId: periodList[0].playPeriodId,
          playPeriodCode: periodList[0].playPeriodCode,
          playPeriodName: periodList[0].playPeriodName,
          playPeriodStartTime: periodList[0].playPeriodStartTime,
          playPeriodEndTime: periodList[0].playPeriodEndTime,
          attrList: []
        }]
        this.traverllerList.forEach(item => {
          arr[0].attrList.push({
            traverllerName: item.traverllerName,
            traverllerPhone: item.traverllerPhone,
            traverllerEmail: item.traverllerEmail,
            traverllerCerType: item.traverllerCerType,
            traverllerCerNo: item.traverllerCerNo
          })
        })
        obj.orderItems = arr
      }
      return obj
    },
    handleSubmit (name) { // 游玩时间校验，通过后触发后续校验
      const token = Vue.ls.get('token')
      const type = Vue.ls.get('type')
      if (!type || !token) {
        this.showModal = true
        return false
      }
      this.spinShow = true
      // this.$router.push({ path: '/individual/purchase/pay', params: { orderId: '1593592157246849858' } })
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.submitFalse = 0
          this.submitTrue = 0
          this.totalFlag = 0
          const refsDom = this.$refs['xComponent']
          refsDom.forEach(item => {
            item.toValidate()
          })
        } else {
          this.spinShow = false
        }
      })
    },
    getResource (date, time) { // 获取游玩日期
      // const productId = this.$route.query.id ? this.$route.query.id : ''
      // const productId = Vue.ls.get('productId')
      // const obj = {
      //   // ticketIdList: [productId]
      //   type: 'main'
      // }
      // httpAction(api.resourceList, 'post', obj).then(res => {
      //   if (res.status === '0') {
      // console.log(date)
      const data = date
      // let periods = data[0].periods
      // console.log(res.responseTime)
      let periods = []
      if(data.length > 0){
        periods = data[0].datePeriodInfos
      }
        // 换算时段
      for (let detail of data) {
        for (let item of detail.datePeriodInfos) {
          for (let period of this.salePeriodList) {
            if (item.code == period.playPeriodCode) {
              // item.playPeriodDisplay = period.playPeriodDisplay
              Object.assign(item,period)
              // console.log(item)
            }
          }
        }
      }
      const currentdate = data[0].saleDate
      // console.log(data[0])
      const currentTime = time.split('.')[0]
      // console.log(currentTime)
      for (let item of periods) {
        const endTime = currentdate + ' ' + item.playPeriodEndTime
        // console.log(endTime)
        // console.log(moment(currentTime) > moment(endTime))
        if (moment(currentTime) > moment(endTime)) {
          item.expiredFlag = true
        }
      }
      data[0].datePeriodInfos = periods
      // console.log(data)
      let numFlag = 0
      let chooseIndex = -1
      // console.log(periods)
      periods.forEach((item, index) => {
        if (item.expiredFlag || item.sellOutFlag) {
          numFlag += 1
        } else {
          if (chooseIndex === -1) chooseIndex = index
        }
      })
      // if (numFlag === periods.length) {
      //   data.resources.splice(0, 1)
      // }
      // if (chooseIndex === -1) chooseIndex = 0
      console.log(data)
      this.$set(this.singleInfo, 'saleDateInfos', data)
      this.$set(this.formCustom, 'playDate', data[0].saleDate)
      this.$set(this, 'playInterval', data[0].datePeriodInfos)
      if (chooseIndex != -1) {
        this.$set(this.formCustom, 'playPeriodId', data[0].datePeriodInfos[chooseIndex].periodCode)
      }
      // this.singleInfo.saleDateInfos = data.resources
      this.$forceUpdate()
      this.spinShow = false
    // } 
      //   else {
      //     this.$Message.warning(res.errorMessage)
      //   }
      // })
    },
    async getSingle () { // 获取订单信息
      this.spinShow = true
      const productId = this.$route.query.id ? this.$route.query.id : ''
      // const productId = Vue.ls.get('productId')
      const obj = {
        productId: productId
      }
      if (!productId) { return false }
      httpAction(api.ticketDetail, 'post', obj).then(res => {
        if (res.status === '0') {
          this.$set(this, 'singleInfo', res.data)
          let data = res.data

          data.needContactHKMTPassport === 'true' && this.contactCerts.push('hkmo_id_card')
          data.needContactIDCard === 'true' && this.contactCerts.push('id_card')
          data.needContactPRC === 'true' && this.contactCerts.push('prc')
          data.needContactPassport === 'true' && this.contactCerts.push('passport')

          data.needTravellerHKMTPassport === 'true' && this.travellerCerts.push('hkmo_id_card')
          data.needTravellerIDCard === 'true' && this.travellerCerts.push('id_card')
          data.needTravellerMilitarycard === 'true' && this.travellerCerts.push('military_card')
          data.needTravellerOther === 'true' && this.travellerCerts.push('other')
          data.needTravellerPRC === 'true' && this.travellerCerts.push('prc')
          data.needTravellerPassport === 'true' && this.travellerCerts.push('passport')

          if (this.contactCerts.length > 0) {
            this.contactCerts.forEach(item => {
              this.contactCerList.push(cerList[item])
            })
          }

          if (this.travellerCerts.length > 0) {
            this.travellerCerts.forEach(item => {
              this.traverllerCerList.push(cerList[item])
            })
          }
          this.traverllerList[0].traverllerCerType = this.traverllerCerList[0].value

          this.$set(this.formCustom, 'saleAgeInfos', res.data.saleAgeInfos)
          // this.singleInfo = res.data
          const date = res.data.saleDateInfos
          console.log(date)
          const time = res.responseTime
          this.getResource(date, time)
        } else {
          this.$Message.warning(res.errorMessage)
        }
      })
      // this.$set(this, 'singleInfo', ticketInfo)
      // this.$set(this.formCustom, 'saleAgeInfos', ticketInfo.saleAgeInfos)
      // this.$forceUpdate()
      // this.spinShow = false
    }
  }
}
</script>

<style scoped lang="less">
  @import "info";
</style>
